<template>
  <div class="setting">
    <el-tabs v-model="activeName">
      <el-tab-pane label="logo设置" name="first">
        <h4 style="margin-top:20px;">logo设置</h4>
        <div class="upload">
          <div class="logo" v-if="logo">
            <img :src="logo">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <h4 style="margin-top:30px;">首页分享图</h4>
        <div class="upload">
          <div class="logo" v-if="homePoster">
            <img :src="homePoster">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess2"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <h4 style="margin-top:30px;">电影节分享图</h4>
        <div class="upload">
          <div class="logo" v-if="filmtestPoster">
            <img :src="filmtestPoster">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess3"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <h4 style="margin-top:30px;">时间线分享图</h4>
        <div class="upload">
          <div class="logo" v-if="timeline_poster">
            <img :src="timeline_poster">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess4"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <h4 style="margin-top:30px;">专题分享图</h4>
        <div class="upload">
          <div class="logo" v-if="topic_poster">
            <img :src="topic_poster">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess6"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <h4 style="margin-top:30px;">资讯台分享图</h4>
        <div class="upload">
          <div class="logo" v-if="information_poster">
            <img :src="information_poster">
          </div>
          <el-upload
            :action="this.$store.state.baseurl+'/image'"
            accept="image/*"
            :headers="headers"
            :on-success="uploadSuccess5"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            name="image"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
          </el-upload>
        </div>
        <el-button type="primary" @click="saveLogo" style="margin-top: 80px;">保 存</el-button>
      </el-tab-pane>
      <el-tab-pane label="首页电影动效">
        <div style="margin-top:20px">
          <el-form ref="form" width="1100px" label-width="80px">
            <el-form-item label="首页电影:">
              <el-select v-model="movie_ids" style="width: 800px;" filterable multiple placeholder="请选择">
                <el-option
                  v-for="item in movies"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                  clearable>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="动效:">
              <el-radio-group v-model="movieShowType">
                <el-radio :label="0">轮播</el-radio>
                <el-radio :label="1">向右滑动</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="primary" style="margin-top: 40px;" @click="saveSlipType">保 存</el-button>
      </el-tab-pane>
      <el-tab-pane label="背景轮播图">
        <el-row>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addItem">添 加</el-button>
        </el-row>
        <el-table
          class="table"
          :data="swiperList"
          style="width: 100%">
          <el-table-column
            label="图片"
            width="180">
            <template slot-scope="scope">
              <img class="img" v-if="scope.row.bannerUrl" :src="scope.row.bannerUrl" @click="selectImg(scope.$index)">
              <el-button v-else size="mini" @click="selectImg(scope.$index)">添加</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="标题"
            width="350">
            <template slot-scope="scope">
              <el-input v-model="scope.row.bannerTitle" placeholder="标题" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="标题(英文)"
            width="350">
            <template slot-scope="scope">
              <el-input v-model="scope.row.bannerTitle_en" placeholder="标题" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="addItem(scope.$index)">添加</el-button>
              <el-button type="text" size="small" @click="deleteItem(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="save">保 存</el-button>
      </el-tab-pane>
      <el-tab-pane label="档案馆默认页面">
        <el-select v-model="defaultIndex">
          <el-option value="0" label="时间线"></el-option>
          <el-option value="1" label="历史切片"></el-option>
          <el-option value="2" label="专题"></el-option>
        </el-select>
        <el-button type="primary" @click="saveArchiveIndex">保 存</el-button>
      </el-tab-pane>
    </el-tabs>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
import { getToken } from '@/utils/auth'
export default {
  name: 'setting',
  components: {
    UploadImg,
    draggable
  },
  data () {
    return {
      headers: {
        Authorization: getToken()
      },
      activeName: 'first',
      swiperList: [],
      info: [],
      logo: '',
      filmtestPoster: '',
      homePoster: '',
      topic_poster: '',
      movies: [],
      movie_ids: [],
      movieShowType: 0,
      timeline_poster: '',
      defaultIndex: '0',
      information_poster: ''
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      request({
        url: '/ui/movie/logo-and-poster'
      }).then(res => {
        this.logo = res.data.logo || ''
        this.filmtestPoster = res.data.filmtest_poster || ''
        this.homePoster = res.data.home_poster || ''
        this.timeline_poster = res.data.timeline_poster || ''
        this.information_poster = res.data.information_poster || ''
        this.topic_poster = res.data.topic_poster || ''
      })
      request({
        url: '/ui/movie/slip-type'
      }).then(res => {
        this.movieShowType = res.data.slip_type || 0
        this.movie_ids = res.data.movie_ids
      })
      request({
        url: '/ui/movie/home-bg-images'
      }).then(res => {
        this.swiperList = res.data.images || []
      })
      request({
        url: '/ui/movie/info-page-setting'
      }).then(res => {
        this.info = res.data.setting || []
      })
      request({
        url: '/movie',
        params: {
          per_page: 500
        }
      }).then(res => {
        this.movies = res.data.list
      })

      request({
        url: '/ui/movie/archive-index',
        params: {
          per_page: 500
        }
      }).then(res => {
        this.defaultIndex = res.data.index
      })
    },
    saveSlipType () {
      request({
        url: '/ui/movie/slip-type',
        method: 'patch',
        data: {
          movie_slip_type: this.movieShowType,
          movie_ids: this.movie_ids
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    saveArchiveIndex () {
      request({
        url: '/ui/movie/archive-index',
        method: 'put',
        data: {
          index: this.defaultIndex
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    saveLogo () {
      request({
        url: '/ui/movie/logo-and-poster',
        method: 'patch',
        data: {
          logo: this.logo,
          filmtest_poster: this.filmtestPoster,
          home_poster: this.homePoster,
          timeline_poster: this.timeline_poster,
          information_poster: this.information_poster,
          topic_poster: this.topic_poster
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    handleUp (index) {
      if (index === 0) return
      let current = JSON.parse(JSON.stringify(this.info[index]))
      let pre = JSON.parse(JSON.stringify(this.info[index - 1]))
      this.info.splice(index, 1, pre)
      this.info.splice(index - 1, 1, current)
    },
    handleDown (index) {
      if (index === this.info.length - 1) return
      let current = JSON.parse(JSON.stringify(this.info[index]))
      let next = JSON.parse(JSON.stringify(this.info[index + 1]))
      this.info.splice(index, 1, next)
      this.info.splice(index + 1, 1, current)
    },
    handleEdit (index, title) {
      this.$prompt('请输入标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: title
      }).then(({ value }) => {
        if (value) {
          this.info[index].title = value
        }
      }).catch(() => {})
    },
    handleOnsubmit () {
      request({
        url: '/ui/movie/info-page-setting',
        method: 'put',
        data: {
          setting: this.info
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    currentChange (index, hidden) {
      this.info[index].is_hidden = hidden ? 0 : 1
    },
    addItem (index) {
      if (typeof index === 'number') {
        this.swiperList.splice(index + 1, 0,{bannerTitle:"",bannerUrl:"",bannerTitle_en:""})
      } else {
        this.swiperList.push({bannerTitle:"",bannerUrl:""})
      }
    },
    deleteItem (index) {
      this.swiperList.splice(index, 1)
    },
    selectImg (index) {
      let list = []
      if (this.swiperList[index]) {
        list = [this.swiperList[index]]
      }
      this.$refs.upload.show(list.bannerUrl, 'other').then(res => {
        if (res.length) {
          this.swiperList.splice(index, 1, {bannerTitle:"",bannerUrl:res[0],bannerTitle_en:""})
        }
      }).catch()
    },
    save () {
      request({
        url: '/ui/movie/home-bg-images',
        method: 'put',
        data: {
          images: this.swiperList
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    uploadSuccess (response, file, fileList) {
      let url = response.data.image.url
      this.logo = url
      this.$myLoading.hide()
    },
    uploadSuccess2 (response, file, fileList) {
      let url = response.data.image.url
      this.homePoster = url
      this.$myLoading.hide()
    },
    uploadSuccess3 (response, file, fileList) {
      let url = response.data.image.url
      this.filmtestPoster = url
      this.$myLoading.hide()
    },
    uploadSuccess4 (response, file, fileList) {
      let url = response.data.image.url
      this.timeline_poster = url
      this.$myLoading.hide()
    },
    uploadSuccess5 (response, file, fileList) {
      let url = response.data.image.url
      this.information_poster = url
      this.$myLoading.hide()
    },
    uploadSuccess6 (response, file, fileList) {
      let url = response.data.image.url
      this.topic_poster = url
      this.$myLoading.hide()
    },
    uploadError (e) {
      this.$myLoading.hide()
      this.$message.error('上传失败，网络不佳!')
    },
    beforeUpload (file) {
      this.$myLoading.show('上传中')
    }
  }
}
</script>
<style lang="less" scoped>
.setting {
  .upload {
    margin-top: 20px;
    margin-bottom: 40px;
    display: flex;
    align-items: flex-end;
    .logo {
      height: 100px;
      min-width: 100px;
      margin-right: 15px;
      img {
        height: 100px;
        width: auto;
      }
    }
  }
  .table {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .img {
    width: auto;
    height: 60px;
  }
  .info {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    line-height: 25px;
    .head {
      padding: 10px 0;
      color: #909399;
      font-weight: 700;
      border-bottom: 1px solid #EBEEF5;
      span {
        padding: 0 10px;
        display: inline-block;
        font-size: 14px;
        &.title {
          width: 200px;
        }
        &.hidden {
          width: 200px;
        }
        .actions {
          min-width: 200px;
        }
      }
    }
    li {
      padding: 10px 0;
      color: #444444;
      border-bottom: 1px solid #EBEEF5;
      span {
        padding: 0 10px;
        display: inline-block;
        font-size: 14px;
        &.title {
          width: 200px;
          .edit {
            padding-left: 10px;
            color: #409EFF;
            cursor: pointer;
          }
        }
        &.hidden {
          width: 200px;
        }
        .actions {
          min-width: 200px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/index.vue